import { render } from "./DashboardReservationCard.vue?vue&type=template&id=ee383128"
import script from "./DashboardReservationCard.vue?vue&type=script&lang=js"
export * from "./DashboardReservationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__